function normalizeOrigin(value) {
  if (value == null || value === "" || value === "undefined") {
    return "";
  }
  return String(value).replace(/\/+$/, "");
}

/** 끝 슬래시 없음. 운영(같은 도메인 nginx 프록시)은 빈 문자열 */
export const baseURL = normalizeOrigin(process.env.API_URL);

/** 기존 `${apiBaseURL}api${path}` 조합용. 운영은 "/" */
export const apiBaseURL = baseURL ? `${baseURL}/` : "/";

export function resolveApiUrl(path) {
  if (path == null || path === "") {
    return path;
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${baseURL}${normalized}`;
}
